import { elakay_API } from "../../config";
import {decryptData}  from '../auth/elakayCryptage'

export const listePM_createStripeCusTomer = async (token, paymentMethod) => {
    try{
   const response = await fetch(`${elakay_API}/stripe/listePM_crateCustomer`, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(paymentMethod)
    })
  
      // Vérifie si le statut est une erreur HTTP
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Erreur d'identification");
    }

    const encryptedData = await response.json(); // doit être au format chiffré (avec iv, salt, etc.)
    const donneesClaires = await decryptData(encryptedData);

    return donneesClaires;

    } catch (err) {
    console.error("Erreur lors du chargement des catégories :", err);
    return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
  }
};


export const updateCustomer = async (token, info) => {
      try{
   const response = await  fetch(`${elakay_API}/stripe/CustomersUpdate`, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(info)
    })

      // Vérifie si le statut est une erreur HTTP
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Erreur d'identification");
    }
    const encryptedData = await response.json(); // doit être au format chiffré (avec iv, salt, etc.)
    const donneesClaires = await decryptData(encryptedData);

    return donneesClaires;

    } catch (err) {
    console.error("Erreur lors du chargement des catégories :", err);
    return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
  }
};


export const createPaymentIntent = async (token, paymentMethodReq) => {
    try{
   const response = await fetch(`${elakay_API}/stripe/createPaymentIntent`, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(paymentMethodReq)
    })

      // Vérifie si le statut est une erreur HTTP
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Erreur d'identification");
    }
  const encryptedData = await response.json(); // doit être au format chiffré (avec iv, salt, etc.)
    const donneesClaires = await decryptData(encryptedData);

    return donneesClaires;

} catch (err) {
    console.error("Erreur lors du chargement des catégories :", err);
    return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
  }
};

export const AttachPaymentMethod = async (token, info) => {
     try{
   const response = await  fetch(`${elakay_API}/stripe/attachPaymentMethod`, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
       
        body: JSON.stringify(info)
    })

      // Vérifie si le statut est une erreur HTTP
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Erreur d'identification");
    }
     const encryptedData = await response.json(); // doit être au format chiffré (avec iv, salt, etc.)
    const donneesClaires = await decryptData(encryptedData);

    return donneesClaires;

} catch (err) {
    console.error("Erreur lors du chargement des catégories :", err);
    return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
  }
};


export const DeletePaymentMethod = async (token, info) => {
     try{
   const response = await fetch(`${elakay_API}/stripe/deletePaymentMethod`, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
       
        body: JSON.stringify(info)
    })

      // Vérifie si le statut est une erreur HTTP
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Erreur d'identification");
    }
   const encryptedData = await response.json(); // doit être au format chiffré (avec iv, salt, etc.)
    const donneesClaires = await decryptData(encryptedData);

    return donneesClaires;

    } catch (err) {
    console.error("Erreur lors du chargement des catégories :", err);
    return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
  }
};


export const CustomersRetrieve = async (token) => {
     try{
   const response = await  fetch(`${elakay_API}/stripe/CustomersRetrieve`, {
        method: "GET",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        }
    })

      // Vérifie si le statut est une erreur HTTP
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Erreur d'identification");
    }
       const encryptedData = await response.json(); // doit être au format chiffré (avec iv, salt, etc.)
    const donneesClaires = await decryptData(encryptedData);

    return donneesClaires;

} catch (err) {
    console.error("Erreur lors du chargement des catégories :", err);
    return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
  }
};

export const get_client_secret = async (token) => {
     try{
   const response = await  fetch(`${elakay_API}/stripe/get_client_secret`, {
        method: "GET",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        }
    })

      // Vérifie si le statut est une erreur HTTP
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Erreur d'identification");
    }
    const encryptedData = await response.json(); // doit être au format chiffré (avec iv, salt, etc.)
    const donneesClaires = await decryptData(encryptedData);

    return donneesClaires;

} catch (err) {
    console.error("Erreur lors du chargement des catégories :", err);
    return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
  }
};



export const PaymentIntent = (token, info) => {
    return fetch(`${elakay_API}/stripe/payment-intent`, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },

        body: JSON.stringify(info)
    })
        .then(response => {
            return response.json();
        })
        .catch(err => {
             return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
        });
};

export const retrievePayment = async (token, info) => {
      try{
   const response = await fetch(`${elakay_API}/stripe/retrievePaymentMethod`, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },

        body: JSON.stringify(info)
    })

      // Vérifie si le statut est une erreur HTTP
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Erreur d'identification");
    }
 const encryptedData = await response.json(); // doit être au format chiffré (avec iv, salt, etc.)
    const donneesClaires = await decryptData(encryptedData);

    return donneesClaires;

} catch (err) {
    console.error("Erreur lors du chargement des catégories :", err);
    return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
  }
};

export const updatePayment = async (token, info) => {
     try{
   const response = await  fetch(`${elakay_API}/stripe/UpdatePaymentMethod`, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },

        body: JSON.stringify(info)
    })

      // Vérifie si le statut est une erreur HTTP
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Erreur d'identification");
    }

     const encryptedData = await response.json(); // doit être au format chiffré (avec iv, salt, etc.)
    const donneesClaires = await decryptData(encryptedData);

    return donneesClaires;

} catch (err) {
    console.error("Erreur lors du chargement des catégories :", err);
    return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
  }
};

export const DeleteCuStID = (token) => {
    return fetch(`${elakay_API}/stripe/DeleteCuStID`, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        }
    })
        .then(response => {
            return response.json();
        })
        .catch(err => {
             return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
        });
};

export const getPaymentIntentView = async (token, id) => {
      try{
   const response = await  fetch(`${elakay_API}/stripe/payment-View/${id}`, {
        method: "GET",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        }
    })

      // Vérifie si le statut est une erreur HTTP
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Erreur d'identification");
    }

 const encryptedData = await response.json(); // doit être au format chiffré (avec iv, salt, etc.)
    const donneesClaires = await decryptData(encryptedData);

    return donneesClaires;

} catch (err) {
    console.error("Erreur lors du chargement des catégories :", err);
    return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
  }
};

export const ListaccountsOrcreateStripeAccount = async (token, info) => {
  
      try{
   const response = await fetch(`${elakay_API}/stripe/List_ACC_Or_CRE_STR_ACC`, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(info)
    })

      // Vérifie si le statut est une erreur HTTP
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Erreur d'identification");
    }

 const encryptedData = await response.json(); // doit être au format chiffré (avec iv, salt, etc.)
    const donneesClaires = await decryptData(encryptedData);

    return donneesClaires;

} catch (err) {
    console.error("Erreur lors du chargement des catégories :", err);
    return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
  }
};


export const CreatBankAccounts = async (token, info) => {
   
    try{
   const response = await  fetch(`${elakay_API}/stripe/CreatBankAccounts`, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(info)
    })  

      // Vérifie si le statut est une erreur HTTP
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Erreur d'identification");
    }

    const encryptedData = await response.json(); // doit être au format chiffré (avec iv, salt, etc.)
    const donneesClaires = await decryptData(encryptedData);

    return donneesClaires;

} catch (err) {
    console.error("Erreur lors du chargement des catégories :", err);
    return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
  }
};

export const CreatExBankAccounts = async (token, info) => {
 
     try{
   const response = await  fetch(`${elakay_API}/stripe/CreatBankAccountsExternal`, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(info)
    })

      // Vérifie si le statut est une erreur HTTP
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Erreur d'identification");
    }

   const encryptedData = await response.json(); // doit être au format chiffré (avec iv, salt, etc.)
    const donneesClaires = await decryptData(encryptedData);

    return donneesClaires;

    } catch (err) {
    console.error("Erreur lors du chargement des catégories :", err);
    return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
  }
};

export const getListBankAccounts = async (token) => {
    try{
   const response = await fetch(`${elakay_API}/stripe/listBankAccounts`, {
        method: "GET",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        }
    })

      // Vérifie si le statut est une erreur HTTP
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Erreur d'identification");
    }

 const encryptedData = await response.json(); // doit être au format chiffré (avec iv, salt, etc.)
    const donneesClaires = await decryptData(encryptedData);

    return donneesClaires;

} catch (err) {
    console.error("Erreur lors du chargement des catégories :", err);
    return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
  }
};

export const postCreatePayout = async (token, info) => {

     try{
   const response = await fetch(`${elakay_API}/stripe/CreatePayout`, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(info)
    })

      // Vérifie si le statut est une erreur HTTP
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Erreur d'identification");
    }
    const encryptedData = await response.json(); // doit être au format chiffré (avec iv, salt, etc.)
    const donneesClaires = await decryptData(encryptedData);

    return donneesClaires;

} catch (err) {
    console.error("Erreur lors du chargement des catégories :", err);
    return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
  }
};

export const postCreateTransfer = (token, info) => {
 
    return fetch(`${elakay_API}/stripe/CreateTransfer`, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(info)
    })
        .then(response => {
            return response.json();
        })
        .catch(err => {
             return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
        });
};

export const getListExternalAccounts = async (token) => {
  try{
   const response = await fetch(`${elakay_API}/stripe/listExternalAccounts`, {
        method: "GET",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        }
    })

      // Vérifie si le statut est une erreur HTTP
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Erreur d'identification");
    }
    
    const encryptedData = await response.json(); // doit être au format chiffré (avec iv, salt, etc.)
    const donneesClaires = await decryptData(encryptedData);

    return donneesClaires;

    } catch (err) {
    console.error("Erreur lors du chargement des catégories :", err);
    return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
  }
};